import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from './pages/Login';
import Home from './pages/Home';
import SilenceLogin from "./pages/SilenceLogin";

// import NotFound from "./pages/NotFound";
import { useStore } from './state/MobxContext';
import GoogleAuth from "./pages/GoogleAuth";
import { observer } from 'mobx-react';
import { getBearer } from "./utils/NetworkService";



function App() {

  const { loginStore } = useStore();

  if (loginStore.loginState.member_no == null && loginStore.isLogin) {
    loginStore.setIsLogin(false);
  }


  return (
    <div className="App">

      <BrowserRouter>
        <Routes>
          {loginStore.isLogin ?
            <Route path="/">
              {getBearer() ?
                <>
                <Route index element={<Home />} />
                <Route path="main" element={<Home />} />
                <Route path="login" element={<Login />} />
                </>
                :
                <>
                  <Route index element={<Login />} />
                  <Route path="tokenLogin" element={<SilenceLogin />} />
                  <Route path="*" element={<Login />} />
                </>
              }

            </Route> 
            :
            <Route path="/">
              {/* <Route index element={<GoogleAuth />} /> */}
              <Route index element={<Home />} />
              <Route path="main" element={<Home />} />
              <Route path="tokenLogin" element={<SilenceLogin />} />
              <Route path="login" element={<Login />} />
              <Route path="GoogleAuth" element={<GoogleAuth />} />
              <Route path="main/login" element={<Login />} />
            </Route>
            
          }
          {/* <Route path="*" element={<NotFound />} /> */}
          {/* <Route path="*" element={loginStore.isLogin ? <Home /> : <GoogleAuth />} /> */}
        </Routes>
      </BrowserRouter>
    </div >
  );
}




export default observer(App);